import { RefObject, useCallback, useEffect, useState } from "react"

export const useIsTextTruncated = (
  ref: RefObject<HTMLElement>,
  deps: unknown[] = []
) => {
  const [isTruncated, setIsTruncated] = useState(false)

  const checkTruncation = useCallback(() => {
    if (ref.current) {
      setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth)
    }
  }, [ref])

  useEffect(() => {
    checkTruncation()
    // Web fonts can still be swapping in when the effect above runs, which
    // skews the measurement — recheck once they're settled.
    document.fonts?.ready.then(checkTruncation)

    const resizeObserver = new ResizeObserver(checkTruncation)
    if (ref.current) resizeObserver.observe(ref.current)
    return () => resizeObserver.disconnect()
  }, [checkTruncation, ...deps])

  return isTruncated
}
